<p-toast />

<app-force-change-password />

<div class="loader" *ngIf="!init"><app-loader></app-loader></div>
<router-outlet *ngIf="init" />
